import React from "react";
import {Card, CardContent, TextField, Tooltip, Typography} from "@mui/material";
import { Log } from "../../models/Log";
import {DataGridPro, GridRenderCellParams} from "@mui/x-data-grid-pro";
import {AuditSeverity} from "../../models/AuditSeverity";
import {Adb, Error, Info, Warning} from "@mui/icons-material";
import moment from "moment/moment";
import {translateFunction} from "../../../../localization/TranslationService";

const translate = translateFunction("SureBaseDocuments");
interface ILogCardProps {
	logs: Log[] | null;
}

export const LogCard: React.FC<ILogCardProps> = ({ logs }) => {
	return (
		<Card>
			<CardContent>
				<Typography variant="h6" component="div">
					System Logs
				</Typography>
				<DataGridPro getRowHeight={() => "auto"} columns={[
					{
						field: "severity",
						headerName: translate("Severity"),
						width: 100,
						renderCell: (params: GridRenderCellParams) => {
							return (
								<Tooltip title={params.row.severity}>
									{params.row.severity === AuditSeverity.Debug ? (
										<Adb color="secondary" />
									):	params.row.severity === AuditSeverity.Trace ? (
										<Adb color="disabled" />
									):	params.row.severity === AuditSeverity.Information ? (
										<Info color="info" />
									) : params.row.severity === AuditSeverity.Warning ? (
										<Warning color="warning" />
									) : (
										<Error color="error" />
									)}
								</Tooltip>
							);
						},

					},
					{
						field: "timeStamp",
						headerName: translate("Time"),
						width: 150,
						renderCell: (params: GridRenderCellParams) => {
							return (
								<>
									{params.row.timeStamp &&
										moment(params.row.timeStamp).format("DD-MM-YYYY HH:mm:ss")}
								</>
							);
						},
					},
					{
						field: "source",
						headerName: translate("Source"),
						width:150,
						sortable: false,
						resizable: true,
					},
					{
						field: "message",
						headerName: translate("Message"),
						width:700,
						sortable: false,
						resizable: true,
						renderCell: (cellValues) => {
							return (
								<TextField
									fullWidth={true}
									value={cellValues.row.message}
									//InputProps={{ disableUnderline: true }}
									multiline
									maxRows={10}
								/>

							);
						}
					},
				]} rows={logs??[]}
				/>
			</CardContent>
		</Card>
	);
};
